import React, { useContext } from 'react';
import { GameContext } from '../contexts/GameContext';
import { getPlayerUnits } from '../models/UnitTypes';
import { UNIT_COSTS } from '../utils/constants';

const UnitSelector = () => {
  const { 
    selectedUnitType, 
    setSelectedUnitType, 
    currency, 
    gameState 
  } = useContext(GameContext);
  
  const playerUnitData = getPlayerUnits();
  
  // Create an array of available units with their properties
  const availableUnits = Object.entries(playerUnitData).map(([key, unit]) => ({
    key,
    name: unit.name,
    emoji: unit.emoji,
    cost: UNIT_COSTS[key],
    canAfford: currency >= UNIT_COSTS[key]
  }));

  if (gameState !== 'placement') return null;

  return (
    <div className="absolute top-16 left-0 z-20 p-2 bg-gray-800 bg-opacity-90 border-r-2 border-b-2 border-green-600 rounded-br-lg">
      <div className="flex flex-col gap-2">
        {availableUnits.map(unit => (
          <button
            key={unit.key}
            className={`
              w-10 h-10 flex items-center justify-center rounded-full
              ${selectedUnitType === unit.key ? 'bg-green-600' : 'bg-gray-700'}
              ${!unit.canAfford ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-600'}
              border-2 ${selectedUnitType === unit.key ? 'border-yellow-400' : 'border-gray-500'}
              text-lg transition-all
            `}
            onClick={() => unit.canAfford && setSelectedUnitType(unit.key)}
            disabled={!unit.canAfford}
            title={`${unit.name} (${unit.cost} currency)`}
          >
            {unit.emoji}
            <span className="absolute right-0 bottom-0 text-xs bg-black bg-opacity-70 rounded-full w-5 h-5 flex items-center justify-center text-white">
              {unit.cost}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default UnitSelector;